import React from "react";
import { useNavigate } from "react-router-dom";
import "./ResourceCollection.css";
import { translate } from "../../app/utils";

const ResourceCollection = (list) => {
  const navigate = useNavigate();
  
  const resourceCollection = [
    {
      title: "Accountancy",
    },
    {
      title: "Anthropology",
    },
    {
      title: "Business Management",
    },
    {
      title: "Computer Science & Technology",
    },
    {
      title: "Economics (Policy, Management & Planning)",
    },
    {
      title: "Education",
    },
    {
      title: "Finance",
    },
    {
      title: "Linguistic Literature",
    },
    {
      title: "Management",
    },
    {
      title: "Psychology",
    },
    {
      title: "Philosophy (Morals & Ethics)",
    },
    {
      title: "Methods of Social Science",
    },
    {
      title: "Sociology",
    },
    {
      title: "Trade & Commerce",
    },
    {
      title: "Health and Wellness",
    },
    {
      title: "Law",
    },
    {
      title: "Public Administration",
    },
    {
      title: "Public Relations",
    },
    {
      title: "Biographies",
    },
  ];
  return (
    <div id="resource-collection-container">
      {resourceCollection.map((item, index) => (
        <div 
          key={index} 
          className="resource-collection-item"
          onClick={() => navigate("/books", { state: { query: item.title } })}
          style={{ cursor: "pointer" }}
        >
          <div className="shade"></div>
          <div className="text">{translate(item.title)}</div>
        </div>
      ))}
    </div>
  );
};

export default ResourceCollection;
